import type RecipientWellWithFindControlViewState from 'owa-recipient-types/lib/types/RecipientWellWithFindControlViewState';
import type { ComposeViewState } from 'owa-mail-compose-store';
import type {
    RecommendationServiceODataMessage,
    RecommendationServiceODataMessageRecipient,
} from 'owa-attachment-suggestions';
import { getCurrentCulture } from 'owa-localize';

export default function getSuggestedAttachmentMessageFromComposeViewState(
    composeViewState: ComposeViewState
): RecommendationServiceODataMessage {
    return {
        '@odata.type': 'Microsoft.OutlookServices.Message',
        Subject: composeViewState.subject,
        Body: {
            '@odata.type': 'Microsoft.OutlookServices.ItemBody',
            Content: composeViewState.content,
            ContentType: composeViewState.bodyType,
        },
        ToRecipients: convertRecipientWell(composeViewState.toRecipientWell),
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (24,44): Argument of type 'RecipientWellWithFindControlViewState | null' is not assignable to parameter of type 'RecipientWellWithFindControlViewState'.
        // @ts-expect-error
        CcRecipients: convertRecipientWell(composeViewState.ccRecipientWell),
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (28,45): Argument of type 'RecipientWellWithFindControlViewState | null' is not assignable to parameter of type 'RecipientWellWithFindControlViewState'.
        // @ts-expect-error
        BccRecipients: convertRecipientWell(composeViewState.bccRecipientWell),
        SingleValueExtendedProperties: [
            {
                PropertyId:
                    'String {00062008-0000-0000-c000-000000000046} Name EntityExtraction/ExtractLanguage1.0',
                Value: JSON.stringify([{ Language: { Locale: getCurrentCulture() } }]),
            },
        ],
    };
}

function convertRecipientWell(
    recipientWell: RecipientWellWithFindControlViewState
): RecommendationServiceODataMessageRecipient[] {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (45,5): Type '{ '@odata.type': "Microsoft.OutlookServices.Recipient"; EmailAddress: { '@odata.type': "Microsoft.OutlookServices.EmailAddress"; Name: string | undefined; Address: string | undefined; }; }[]' is not assignable to type 'RecommendationServiceODataMessageRecipient[]'.
    // @ts-expect-error
    return recipientWell?.recipients?.map(recipient => ({
        '@odata.type': 'Microsoft.OutlookServices.Recipient',
        EmailAddress: {
            '@odata.type': 'Microsoft.OutlookServices.EmailAddress',
            Name: recipient?.displayText || recipient?.persona?.DisplayName,
            Address: recipient?.persona?.EmailAddress?.EmailAddress,
        },
    }));
}
